import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Support from "@/pages/Support";
import Install from "@/pages/Install";
import BetaFeedback from "@/pages/BetaFeedback";
import AdminBetaFeedback from "@/pages/AdminBetaFeedback";
import NotFound from "@/pages/NotFound";
import ResetPasswordRedirect from "@/pages/ResetPasswordRedirect";
import { captureAttribution } from "@/utils/attribution";

// Re-runs on every route change so ref/UTM params on any entry URL are
// captured to sessionStorage (first-touch model — never overwritten).
const AttributionCapture = () => {
  const location = useLocation();
  useEffect(() => {
    try {
      captureAttribution();
    } catch (_) {}
  }, [location.pathname, location.search]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AttributionCapture />
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              background: "rgba(255,255,255,0.9)",
              backdropFilter: "blur(18px)",
              border: "1px solid rgba(205,189,253,0.8)",
              color: "#0B1D3A",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/support" element={<Support />} />
          <Route path="/install" element={<Install />} />
          <Route path="/beta-feedback" element={<BetaFeedback />} />
          <Route path="/admin/beta-feedback" element={<AdminBetaFeedback />} />
          <Route path="/reset-password" element={<ResetPasswordRedirect />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
